import React, { useState, useEffect } from 'react';

function FamilyMemberForm({ onSubmit, initialData = {}, onCancel }) {
  const [formData, setFormData] = useState({
    full_name: '',
    relationship: '',
    is_primary_guardian: false,
    phone: '',
    address: '',
    notes: '',
  });

  const isEditing = !!initialData.id;

  useEffect(() => {
    if (isEditing) {
      setFormData({
        full_name: initialData.full_name || '',
        relationship: initialData.relationship || '',
        is_primary_guardian: initialData.is_primary_guardian || false,
        phone: initialData.contact_info?.phone || '',
        address: initialData.contact_info?.address || '',
        notes: initialData.notes || '',
      });
    }
  }, [initialData, isEditing]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { phone, address, ...rest } = formData;
    const finalData = {
      ...rest,
      contact_info: { phone, address },
    };
    onSubmit(finalData);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
        <form onSubmit={handleSubmit} className="p-6">
          <h2 className="text-xl font-bold text-slate-800 mb-4">{isEditing ? 'Edit' : 'Add'} Family Member</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Full Name</label>
              <input type="text" name="full_name" value={formData.full_name} onChange={handleChange} required />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Relationship</label>
              <input type="text" name="relationship" placeholder="e.g., Mother, Uncle" value={formData.relationship} onChange={handleChange} required />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Phone</label>
              <input type="text" name="phone" value={formData.phone} onChange={handleChange} />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Address</label>
              <input type="text" name="address" value={formData.address} onChange={handleChange} />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-slate-700 mb-1">Notes</label>
              <textarea name="notes" value={formData.notes} onChange={handleChange} rows="3" />
            </div>
            <div className="md:col-span-2 flex items-center">
              <input type="checkbox" name="is_primary_guardian" id="is_primary_guardian" checked={formData.is_primary_guardian} onChange={handleChange} className="h-4 w-4 rounded border-gray-300 text-gold focus:ring-gold" />
              <label htmlFor="is_primary_guardian" className="ml-2 block text-sm text-slate-900">Set as Primary Guardian</label>
            </div>
          </div>
          <div className="flex justify-end gap-4 pt-4 mt-6 border-t border-slate-200">
            <button type="button" onClick={onCancel} className="bg-slate-200 text-slate-700 hover:bg-slate-300 font-bold py-2 px-4 rounded-lg">Cancel</button>
            <button type="submit" className="bg-gold text-white hover:bg-gold-dark font-bold py-2 px-4 rounded-lg">Save Member</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FamilyMemberForm;